import { createAxios } from "./axiosHttpMarconi";

export const tarifaGenericosService = {
  getTarifasGenericos,
  deleteTarifaGenerico,
  postTarifaGenerico,
  updateTarifaGenerico,
  getTarifaGenericoById,
};

function getTarifasGenericos(pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/tarifas-genericos`;
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${
      pagination.perPage
    }`;
  } else {
    urlPath += "?page=0";
  }
  urlPath += getUrlPath(filters);
  return axios.get(urlPath);
}

function getUrlPath(filters) {
  let urlPath = "";
  if (filters && filters.franquicia) {
    urlPath += `&franquicia=${filters.franquicia}`;
  }
  return urlPath;
}

function deleteTarifaGenerico(tarifaId) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/tarifas-genericos/${tarifaId}`;
  return axios.delete(urlPath);
}

function postTarifaGenerico(request) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/tarifas-genericos`;
  return axios.post(urlPath, request);
}

function updateTarifaGenerico(id, body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/tarifas-genericos/${id}`;
  return axios.put(urlPath, body);
}

function getTarifaGenericoById(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/tarifas-genericos/${id}`;
  return axios.get(urlPath);
}
